// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/tabs/templates/tab_header.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent");

function render(input, out, __component, component, state) {
  var data = input;

  out.e("li", null, "0", component, 1)
    .e("a", {
        href: "javascript:void(0)",
        id: input.tabName + "-header",
        "class": "tablinks",
        "data-tabname": input.tabName
      }, "1", component, 1)
      .t(input.title, component);
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
